/*
    Expose File Upload Type IDs
        SELECT *
        FROM [MCU].[FileUploadTypes]
*/
export const clientMerge = '7ADB28C3-7E41-42E2-A44E-F4B259F9C7D2';
export const clientAcquisitionCode = '007BA321-C7D9-4A8D-AD82-92FF9EC218B2';
export const miniConversion_Customers = '3210DBA4-2384-4576-97AA-0EA7F287E8F6';
export const miniConversion_Policies = 'EEC3711E-7B09-4837-9E34-DFF38AD0AF26';
export const miniConversion_Contacts = 'BF59FD7E-027F-4C22-A3F4-3EEA7E4A7710';
export const miniConversion_Activities = '321A8988-ADFA-4A6D-B82B-4A02A8FF6F59';
